import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const ReferralRedirect = () => {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // You can map codes here
    const referralMap = {
      b97: 'G-F2432',
      sacha:'F-F3949',
      // add more if needed
    };

    const normalizedCode = code.toLowerCase();
    const referralCode = referralMap[normalizedCode];

    if (referralCode) {
      navigate(`/?referralCode=${referralCode}`, { replace: true });
    } else {
      navigate('/', { replace: true });
    }
  }, [code, navigate]);

  return null; // No visual render needed
};

export default ReferralRedirect;
